import type { ICampaignCategory } from '../../../components/EsForm/CampaignCategorySelector';

export type SubmissionState = 'public_submission' | 'private_submission';

export interface ContestTierRow {
    label: string;
    fee: number;
    slots?: number;
    currency: string;
    starts_at?: string | null;
    ends_at?: string | null;
}

export interface ContestWizardState {
    submission_state: SubmissionState;
    submission_state_message: string;
    title: string;
    description: string;
    feature_image_preview: string | null;
    feature_image_file: File | null;
    mobile_feature_image_preview: string | null;
    mobile_feature_image_file: File | null;
    requirements: string[];
    tag: string[];
    genre: string[];
    categories_enabled: boolean;
    categories: ICampaignCategory[];
    late_entry: boolean;
    preselection_enabled: boolean;
    entry_type: 'single' | 'multiple';
    /** Omit or null for unlimited applications. */
    max_participants: number | null;
    /** Hide public applications count and entry playlists. */
    hide_submissions_count: boolean;
    contest_phases_enabled: boolean;
    contest_phase_dates: Array<{ phase: string; date_started: string; expiration_date: string }>;
    voting_required: boolean;
    voting_type: string;
    rating: string;
    contest_reference: string[];
    playlist: string[];
    technical_spec: {
        max_duration: number;
        min_duration: number;
        project_format: string;
        media_type: string;
    };
    score_criteria: string[];
    contest_media_files: File[];
    /** Active category index while in category builder sub-flow */
    editingCategoryIndex: number | null;
}

export const CONTEST_WIZARD_INITIAL: ContestWizardState = {
    submission_state: 'public_submission',
    submission_state_message: 'Submissions can be public to be eligible. This enables voting options.',
    title: '',
    description: '',
    feature_image_preview: null,
    feature_image_file: null,
    mobile_feature_image_preview: null,
    mobile_feature_image_file: null,
    requirements: [],
    tag: [],
    genre: [],
    categories_enabled: true,
    categories: [],
    late_entry: false,
    preselection_enabled: false,
    entry_type: 'multiple',
    max_participants: null,
    hide_submissions_count: false,
    contest_phases_enabled: false,
    contest_phase_dates: [],
    voting_required: false,
    voting_type: 'daily',
    rating: 'PG-13',
    contest_reference: [],
    playlist: [],
    technical_spec: {
        max_duration: 2,
        min_duration: 1,
        project_format: 'video',
        media_type: 'video',
    },
    score_criteria: [],
    contest_media_files: [],
    editingCategoryIndex: null,
};

export type ContestAiAssistContext = 'identity' | 'category' | 'requirements' | 'timeline' | 'judging' | 'awards';
